export default "__VITE_ASSET__36b5a1e7__"